// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Styles
import './StyledPopupInputContainer.scss';

const StyledPopupInputContainer = (props) => {
    const { children, className, disabled, readOnly, inputRef } = props;

    const onClick = () => {
        inputRef && inputRef.current && inputRef.current.focus();
    };

    return (
        <div
            className={classNames('StyledPopupInputContainer', className, { disabled, 'read-only': readOnly })}
            onClick={onClick}
        >
            {children}
        </div>
    );
};

StyledPopupInputContainer.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    inputRef: PropTypes.object,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
};

export default StyledPopupInputContainer;
